module.exports = __webpack_public_path__ + "assets/img/tech-11.1dda02fc.svg";